const PreviewTableOne = ({ ordLevel }) => {
    return ( 
            <table className="mt-2">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Year</th>
                        <th>O' Level Subject</th>
                        <th>Examination Board</th>
                        <th>Results / Grade</th>
                    </tr>
                    </thead>
                    <tbody>  
                        {
                            ordLevel && ordLevel.map(level => (
                                <tr key={level.subject}>
                                    <td>{ level.month }</td>
                                    <td>{ level.year }</td>    
                                    <td>{ level.subject }</td>    
                                    <td>{ level.board }</td>    
                                    <td>{ level.grade }</td> 
                                </tr>

                            ))
                        }           
                </tbody>
            </table>
     );
}
 
export default PreviewTableOne;